<template>
  <WdsText size="sm" color="gray-500">
    {{ displayDate }}
  </WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import useDate from '@/composables/useDate'

const PaymentRequestRequestedAtColumn = graphql(`
  fragment PaymentRequestRequestedAtColumn on PaymentRequest {
    id
    issuedAt
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestRequestedAtColumn>
}>()

const column = computed(() => useFragment(PaymentRequestRequestedAtColumn, props.row))

const formattedDate = useDate(
  computed(() => column.value.issuedAt),
  'MMM D, YYYY',
)

const displayDate = computed(() =>
  formattedDate.isValid.value ? formattedDate.date.value : '-',
)
</script>

